export default "__VITE_ASSET__DcyOz2jl__"